import React from "react";

const VoiceCampaigns = () => {
  return <div>Voice Campaigns</div>;
};

export default VoiceCampaigns;
